import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'eas-editor-eligibility-dialog-delete',
    templateUrl: './editor-eligibility-dialog-delete.component.html',
    styleUrls: ['./editor-eligibility-dialog-delete.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityDialogDeleteComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<EditorEligibilityDialogDeleteComponent>,
  ) {

  }

  ngOnInit() {

  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onDismiss() {
    this.dialogRef.close(false);
  }
}
